import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import CustomNav from '../components/CustomNav';
import Footer from '../components/Footer';
import NewNav from '../components/NewNav';
import axios from 'axios';
import config from "../config.js";

function NewContact() {

    const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
      axios.post(`${config.API_BASE_URL}/api/contact`, formData)
      .then(response => {
        console.log('Form Submitted Successfully', response.data);
        window.location.reload();
      })
      .catch(error => {
        console.error('Error submitting form', error);
      });
  };
  return (
    <div className="new-contact-page">
        {/* <CustomNav/> */}
        <NewNav/>
    <section className="contact-page-sec">
    <Container>
      <Row>
        <Col md={6} className="mb-4">
          <div className="contact-info">
            <div className="contact-info-item">
              <div className="contact-info-icon">
                <i className="fas fa-map-marked"></i>
              </div>
              <div className="contact-info-text">
                <h2>address</h2>
                <span>LAL BADSHAH ROAD MULTAN ROAD, KHANPUR, LAHORE,</span>
                <span>Pakistan, LAHORE</span>
              </div>
            </div>
          </div>
        </Col>
        <Col md={6} className="mb-4">
          <div className="contact-info">
            <div className="contact-info-item">
              <div className="contact-info-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <div className="contact-info-text">
                <h2>E-mail</h2>
                <span>info@orionlightingpvtltd.com</span>
              </div>
            </div>
          </div>
        </Col>
     
      </Row>
      <Row>
        <Col md={6}>
          <div className="contact-page-form">
            <h2>Get in Touch</h2>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <div className="single-input-field">
                    <Form.Control
                      type="text"
                      placeholder="Your Name"
                      name="name"
                      value={formData.name}
                    onChange={handleChange} 
                    required 
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className="single-input-field">
                    <Form.Control
                      type="email"
                      placeholder="E-mail"
                      name="email"
                    value={formData.email}
                    onChange={handleChange} 
                    required 
                    />
                  </div>
                </Col>
                <Col md={12} >
                  <div className="single-input-field" style={{marginLeft:"-15px"}}>
                    <Form.Control
                      type="text"
                      placeholder="Phone Number"
                      name="phone"
                      value={formData.phone}
                    onChange={handleChange} 
                    required 
                    />
                  </div>
                </Col>
                
                <Col md={12} className="message-input">
                  <div className="single-input-field">
                    <Form.Control
                      as="textarea"
                      rows={4}
                      placeholder="Write Your Message"
                      name="message"
                      value={formData.message}
                    onChange={handleChange} 
                    required 
                    />
                  </div>
                </Col>
                <Col md={12} className='mb-3'>
                  <div className="single-input-fieldsbtn">
                    <Button type="submit">Send Now</Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </div>
        </Col>
        <Col md={6}>
          <div className="contact-page-map">
            <iframe
              src="https://www.google.com/maps?q=ORION+LIGHTING+PVT+LTD,+LAL+BADSHAH+ROAD,+Multan+Rd,+Khanpur,+Lahore,+53710&output=embed"
              width="100%"
              height="450"
              frameBorder="0"
              style={{ border: "0" }}
              allowFullScreen
            ></iframe>
          </div>
        </Col>
      </Row>
    </Container>
  </section>
  <Footer/>
    </div>

  )
}

export default NewContact